import React from "react"
import S from "../Sushi/style"

const Others = (props) => {
    const noodles = props.noodles ? props.noodles : []
    const noodlesList = noodles.map((noodle, i) => {
        return(
            <S.Item key={i}>
                <S.Name>{noodle.name}</S.Name>
                <S.Price>${noodle.price}</S.Price>
            </S.Item>
        )
    })
    const salads = props.salads ? props.salads : []
    const saladsList = salads.map((salad, i) => {
        return(
            <S.Item key={i}>
                <S.Name>{salad.name}</S.Name>
                <S.Price>${salad.price}</S.Price>
            </S.Item>
        )
    })
    const donburi = props.donburi ? props.donburi : []
    const donburiList = donburi.map((donburi, i) => {
        return(
            <S.Item key={i}>
                <S.Name>{donburi.name}</S.Name>
                <S.Price>${donburi.price}</S.Price>
            </S.Item>
        )
    })
    const desserts = props.desserts ? props.desserts : []
    const dessertsList = desserts.map((dessert, i) => {
        return(
            <S.ItemDescriptionBox key={i}>
                <S.Item description={dessert.description}>
                    <S.Name>{dessert.name}</S.Name>
                    <S.Price>${dessert.price}</S.Price>
                </S.Item>
            <S.Description>{dessert.description}</S.Description>
            </S.ItemDescriptionBox>
        )
    })
    return(
        <S.Container1>
            <S.Container2>
                <S.List>
                    <S.SubCategory>Noodles</S.SubCategory>
                    {noodlesList}
                    <S.SubCategory>Salads</S.SubCategory>
                    {saladsList}
                    <S.SubCategory>Donburi</S.SubCategory>
                    {donburiList}
                    <S.SubCategory>Desserts</S.SubCategory>
                    {dessertsList}
                </S.List>
            </S.Container2>
        </S.Container1>
    )
}

export default Others